export default __webpack_public_path__ + "static/media/led.ea45525b.png";